export const GLOBAL_STYLES = {
    DIALOG_CONTENT_WITH_SPACING: 'dialog--content-with-spacing',
    INPUT_FIELD_FULL_WIDTH: 'input-field--full-width'
}